<template>
	<div class="signin-wrapper">
		<!-- Loading Inicial -->
		<div v-if="isLoading" class="nps-initial-loading">
			<div class="nps-initial-loading-container">
				<div class="nps-initial-spinner"></div>
				<span class="nps-initial-loading-text">Carregando...</span>
			</div>
		</div>

		<!-- Mensagem de Erro -->
		<div v-else-if="isMessage && !unsubscribe" class="nps-error-container">
			<div class="signin-box modify bd-0 wd-750">
				<div class="nps-error-content">
					<div class="nps-error-icon nps-error-icon-red" v-if="isError" >
						<svg xmlns="http://www.w3.org/2000/svg" height="80px" viewBox="0 -960 960 960" width="80px" fill="#28a745"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448ZM480-480Z"/></svg>
						
					</div>
					<div class="nps-error-icon nps-error-icon-green" v-else>
						<svg xmlns="http://www.w3.org/2000/svg" height="80px" viewBox="0 -960 960 960" width="80px" fill="#dc3545"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
					</div>
					<h2 class="nps-error-title">{{ titleMessage }}</h2>
					<p class="nps-error-message">{{ textMessage }}</p>
				</div>
			</div>
		</div>

		<!-- Formulário -->
		<form v-else-if="!unsubscribe" @submit.prevent="onSubmit()">
			<div class="signin-box bd-0 wd-750">
				
				<!-- Header Section - Centralizado -->
				<div class="nps-header tx-center">
					<img :src="tenantLogo" alt="Logo" width="250" class="nps-logo" />

					<h2 class="signin-title-primary mg-t-40">Sua opinião é muito importante para nós!</h2>

					<h4 class="signin-title-secondary mg-b-20 mg-t-10">
						Você está avaliando sua experiência no atendimento referente ao processo abaixo:
					</h4>

					<div class="nps-id-container mg-b-30 mg-t-20">
						<span class="nps-id-label">{{ processReference }}</span>
					</div>
				</div>

				<!-- Form Content -->
				<div class="nps-container">
					<p class="nps-question tx-16 mg-b-20">
						Em uma escala de 1 a 10, o quanto você recomendaria a {{ tenantAlias }} para um amigo ou colega?
					</p>

					<div class="nps-buttons-container">
						<button
							v-for="score in 10"
							:key="score"
							type="button"
							class="nps-button"
							:class="{ 'nps-button-selected': selectedScore === score }"
							:style="getButtonStyle(score)"
							:aria-label="`Selecionar nota ${score}`"
							:aria-pressed="selectedScore === score"
							@click="selectScore(score)"
						>
							{{ score }}
						</button>
					</div>

					<div class="nps-comment-section mg-t-40">
						<p class="nps-comment-label tx-16  mg-b-15">
							Obrigada por compartilhar sua avaliação.
						</p>
						<label class="tx-16">
							Se desejar, conte pra gente o que funcionou bem ou o que podemos melhorar (Opcional). 
						</label>
						<textarea v-model="comment" class="nps-comment-textarea" rows="4" aria-label="Campo de comentário opcional"></textarea>
					</div>

					<div v-if="selectedScore !== null" class="nps-submit-container mg-t-30">
						<button
							v-if="!isSubmitting"
							type="submit"
							class="btn btn-primary btn-block btn-signin nps-submit-btnm btn-color-primary mb-0"
						>
							ENVIAR RESPOSTA
						</button>
						<div v-else class="nps-loading-container">
							<div class="nps-spinner"></div>
							<span class="nps-loading-text">ENVIANDO...</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Footer -->
			<div class="nps-footer">
				<p class="mg-t-20 mg-b-0 tx-12 tx-center">
					Copyright © {{ new Date() | moment("YYYY") }}
				</p>
				<p class="tx-11 tx-center">
					Todos os direitos reservados à {{ tenantName }}.
				</p>
			</div>
		</form>

		<div v-else-if="unsubscribe" class="nps-unsubscribe-container">
			<div class="signin-box bd-0 wd-750">
				<div class="nps-unsubscribe-content">
					<div class="nps-unsubscribe-header tx-center mg-b-30">
						<img :src="tenantLogo" alt="Logo" width="250" class="nps-logo" />
					</div>
					<h2 class="signin-title-primary tx-center mb-3">Deseja deixar de receber nossas pesquisas de satisfação?</h2>
					<p class="signin-title-secondary tx-left mb-2 nps-error-message">
						Se você confirmar, não enviaremos mais pesquisas de satisfação relacionadas aos processos da {{ tenantAlias }}.
					</p>
					<p class="signin-title-secondary tx-left mg-t-10 tx-14 mb-2 nps-error-message" style="color: #6c757d;">
						Outras comunicações e informações importantes da {{ tenantAlias }}. continuarão sendo enviadas normalmente.
					</p>
					<p class="signin-title-secondary tx-left mg-t-15 tx-14 mb-0 nps-error-message">
						Agradecemos por ter participado até aqui. Sempre que quiser, você poderá voltar a receber nossas pesquisas.
					</p>
					<div class="nps-unsubscribe-button-container mg-t-30">
						<button
							v-if="!isSubmitting"
							type="button"
							@click.prevent="handleUnsubscribe"
							class="btn btn-primary btn-block btn-signin nps-submit-btnm btn-color-primary mb-0"
						>
							CONFIRMAR DESINSCRIÇÃO
						</button>
						<div v-else class="nps-loading-container">
							<div class="nps-spinner"></div>
							<span class="nps-loading-text">PROCESSANDO...</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

  <script>
  import config from "@/config.js";
  import Axios from "axios";
  export default {
	name: "CustomerNPS",
	data() {
	  return {
		token: this.$route.params.token,
		unsubscribe: false,
		tenantLogo: null,
		tenantTrading: null,
		tenantName: null,
		selectedScore: null,
		tenantAlias: null,
		processReference: null,
		comment: '',
		isSubmitting: false,
		isLoading: true,
		isSupport: false,
		isMessage: false,
		isError: false,
		textMessage: null,
		titleMessage: null,
	  };
	},
	methods: {
		selectScore(score) {
			this.selectedScore = score;
		},
		getButtonStyle(score) {
			let backgroundColor = '';
			
			if (score <= 1) {
				backgroundColor = '#dc3545'; // Vermelho escuro
			} else if (score <= 3) {
				backgroundColor = '#fd7e14'; // Laranja
			} else if (score <= 6) {
				backgroundColor = '#ffc107'; // Amarelo
			} else if (score <= 8) {
				backgroundColor = '#28a745'; // Verde claro
			} else {
				backgroundColor = '#198754'; // Verde escuro
			}
			
			return {
				backgroundColor: backgroundColor,
				color: '#ffffff',
			};
		},
		async onSubmit() {
			if (this.selectedScore === null) {
				return;
			}
			this.isSubmitting = true;
			
			await Axios.post(`${config.env.API_DEFAULT.host}/process-nps/request/${this.$route.params.token}`, {
				score: this.selectedScore,
				observation: this.comment,
			}).then(response => {
				setTimeout(() => {
					this.isSubmitting = false;
					this.isError = false;
					this.titleMessage = 'Pesquisa de satisfação';
					this.textMessage = 'Resposta enviada com sucesso!';
					this.isMessage = true;
				}, 2000);
			}).catch(error => {
				console.log('error', error.response.data);
				this.isSubmitting = false;
				this.titleMessage = 'Erro ao enviar resposta';
				this.textMessage = 'Não foi possível enviar a resposta. Tente novamente mais tarde.';
				this.isError = true;
				this.isMessage = true;
			});
			
		},
		async handleUnsubscribe() {
			this.isSubmitting = true;
			
			try {
				await Axios.post(`${config.env.API_DEFAULT.host}/process-nps/unsubscribe/${this.$route.params.token}`)
					.then(response => {
						setTimeout(() => {
							this.isSubmitting = false;
							this.unsubscribe = false;
							this.isMessage = true;
							this.isError = false;
							this.titleMessage = 'Confirmação realizada!';
							this.textMessage = `Você não receberá mais pesquisas de satisfação relacionadas aos processos da ${this.tenantAlias}. Obrigado por participar. `;
						}, 2000);
					})
					.catch(error => {
						console.log('error', error.response?.data);
						this.isSubmitting = false;
						this.isError = true;
						this.titleMessage = 'Erro ao processar desinscrição';
						this.textMessage = 'Não foi possível processar sua desinscrição. Tente novamente mais tarde.';
						this.isMessage = true;
					});
			} catch (error) {
				console.log('error', error);
				this.isSubmitting = false;
				this.isError = true;
				this.titleMessage = 'Erro ao processar desinscrição';
				this.textMessage = 'Não foi possível processar sua desinscrição. Tente novamente mais tarde.';
				this.isMessage = true;
			}
		},
	},
	async mounted() {  

		const unsubscribeParam = this.$route.query?.unsubscribe;
		if (unsubscribeParam !== undefined && unsubscribeParam === 'true') {
			this.unsubscribe = true;
		}
		
		await Axios.get(`${config.env.API_DEFAULT.host}/process-nps/request/token/${this.$route.params.token}`)
		.then(response => {
			if (response.data.data) {
				this.isSupport = response.data.data.isSowport;
				this.processReference = response.data.data.processReference;
			}
		}).catch(error => {
			console.log('error', error.response.data);

			if (error.response.data?.status === 'BAD_REQUEST') {
				this.isError = false;
				this.textMessage = 'Você já respondeu esta pesquisa! Obrigado por participar.';
			} else {
				this.textMessage = 'Não foi possível localizar a pesquisa de satisfação para o token informado.';
				this.isError = true;
			}
			this.titleMessage = 'Pesquisa de satisfação';
			this.isMessage = true;
		});

		if(this.isSupport) {
			this.tenantAlias = 'Sowport Importação e Distribuição';
			this.tenantName = 'Sowport Importação e Distribuição LTDA';
			this.tenantLogo = 'https://s3.sa-east-1.amazonaws.com/public.sowport.com.br/logo/logo-azul-naval.png';
		} else {
			this.tenantAlias = 'Prime Internacional';
			this.tenantName = 'Prime Internacional Comércio Exterior LTDA';
			this.tenantLogo = 'https://s3.sa-east-1.amazonaws.com/public.prime.com.vc/logo/nova/logo-horizontal-azul.svg';
		}

		if(this.unsubscribe) {
			this.isLoading = false;
			return;
		}
		
		// Captura o parâmetro score da query string
		const scoreParam = this.$route.query.score;
		if (scoreParam !== undefined) {
			const score = parseInt(scoreParam, 10);
			if (!isNaN(score) && score >= 1 && score <= 10) {
				this.selectedScore = score;
			}
		}

		// Finaliza o loading inicial
		this.isLoading = false;
	},
	created() {},
  };
  </script>

  <style scoped>
  /* Wrapper com fundo gradiente */
  .signin-wrapper {
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	min-height: 100vh;
	padding: 40px 20px;
	display: flex;
	align-items: center;
	justify-content: center;
  }

  /* Card branco com sombra e bordas arredondadas */
  .signin-box {
	background: #ffffff !important;
	border-radius: 12px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
	padding: 40px;
	max-width: 750px;
	width: 100%;
	margin: 0 auto;
  }

  .signin-box.modify {
	max-width: 600px !important;
  }

  /* Header Section */
  .nps-header {
	margin-bottom: 30px;
  }

  .nps-logo {
	transition: transform 0.3s ease;
  }

  .nps-logo:hover {
	transform: scale(1.05);
  }

  /* ID Label - Código do Processo destacado */
  .nps-id-container {
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
  }

  .nps-id-label {
	font-size: 24px;
	font-weight: 700;
	color: #212529;
	letter-spacing: 2px;
	background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
	padding: 12px 24px;
	border-radius: 8px;
	border: 2px solid #dee2e6;
	display: inline-block;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  /* Container do formulário */
  .nps-container {
	padding: 0;
  }

  /* Pergunta NPS */
  .nps-question {
	color: #212529;
	font-weight: 500;
	line-height: 1.6;
	text-align: left;
  }

  /* Container dos botões NPS */
  .nps-buttons-container {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
	margin: 30px auto;
	max-width: 100%;
  }

  .btn-color-primary {
	background-color: #104375 !important;
	border-color: #104375 !important;
	background-image: none !important;
  }

  /* Botões NPS */
  .nps-button {
	width: 50px;
	height: 50px;
	border: 2px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	font-size: 18px;
	font-weight: 700;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	position: relative;
  }

  .nps-button:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
	border-color: rgba(0, 0, 0, 0.2);
  }

  .nps-button:active {
	transform: translateY(0);
  }

  .nps-button-selected {
	border: 3px solid #000 !important;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
	transform: translateY(-2px) scale(1.05);
	font-weight: 700;
	z-index: 1;
  }

  /* Seção de comentário */
  .nps-comment-section {
	width: 100%;
	margin: 0 auto;
	text-align: left;
  }

  .nps-comment-label {
	color: #212529;
	font-weight: 500;
	line-height: 1.6;
  }

  /* Textarea */
  .nps-comment-textarea {
	width: 100%;
	min-height: 120px;
	padding: 15px;
	border: 1px solid #e2e2e2;
	border-radius: 6px;
	font-size: 14px;
	font-family: inherit;
	resize: vertical;
	outline: none;
	transition: all 0.3s ease;
	background-color: #fafafa;
	line-height: 1.5;
  }

  .nps-comment-textarea:focus {
	border-color: #1b84e7;
	background-color: #fff;
	box-shadow: 0 0 0 3px rgba(27, 132, 231, 0.1);
  }

  .nps-comment-textarea::placeholder {
	color: #999;
	opacity: 0.7;
  }

  /* Botão de envio */
  .nps-submit-container {
	animation: fadeInUp 0.4s ease;
  }

  @keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
  }

  .nps-submit-btn {
	padding: 12px 24px;
	font-size: 16px;
	font-weight: 600;
	border-radius: 6px;
	transition: all 0.3s ease;
	margin-bottom: 0;
  }

  .nps-submit-btn:hover:not(:disabled) {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nps-submit-btn:active:not(:disabled) {
	transform: translateY(0);
  }

  .nps-submit-btn:disabled {
	opacity: 0.7;
	cursor: not-allowed;
  }

  /* Loading Container */
  .nps-loading-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 15px;
	padding: 20px;
	animation: fadeInUp 0.4s ease;
  }

  /* Spinner */
  .nps-spinner {
	width: 40px;
	height: 40px;
	border: 4px solid rgba(16, 67, 117, 0.2);
	border-top-color: #104375;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
	to {
		transform: rotate(360deg);
	}
  }

  /* Loading Text */
  .nps-loading-text {
	font-size: 16px;
	font-weight: 600;
	color: #104375;
	letter-spacing: 1px;
  }

  /* Loading Inicial - Full Screen */
  .nps-initial-loading {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
  }

  .nps-initial-loading-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
  }

  .nps-initial-spinner {
	width: 60px;
	height: 60px;
	border: 5px solid rgba(16, 67, 117, 0.2);
	border-top-color: #104375;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;
  }

  .nps-initial-loading-text {
	font-size: 18px;
	font-weight: 600;
	color: #104375;
	letter-spacing: 1px;
  }

  /* Container de Erro */
  .nps-error-container {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 50vh;
	padding: 40px 20px;
  }

  .nps-error-content {
	text-align: center;
	padding: 40px 10px;
  }

  .nps-error-icon {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
  }

  .nps-error-icon svg {
	width: 80px;
	height: 80px;
  }

  .nps-error-icon-red svg {
	fill: #dc3545;
  }

  .nps-error-icon-green svg {
	fill: #28a745;
  }

  .nps-error-title {
	font-size: 24px;
	font-weight: 700;
	color: #212529;
	margin-bottom: 15px;
  }

  .nps-error-message {
	font-size: 18px;
	color: #212529;
	line-height: 1.6;
	margin: 0;
  }

  /* Footer */
  .nps-footer {
	margin-top: 30px;
	text-align: center;
  }

  /* Responsividade */
  @media (max-width: 768px) {
	.signin-wrapper {
		padding: 20px 10px;
	}

	.signin-box {
		padding: 30px 20px;
		border-radius: 8px;
	}

	.nps-container {
		padding: 0;
	}

	.nps-question,
	.nps-comment-label {
		font-size: 14px;
		line-height: 1.5;
	}

	.nps-button {
		width: 45px;
		height: 45px;
		font-size: 16px;
	}

	.nps-buttons-container {
		gap: 8px;
		padding: 0 5px;
	}

	.nps-comment-section {
		margin-top: 30px;
	}

	.nps-comment-textarea {
		min-height: 100px;
		padding: 12px;
		font-size: 14px;
	}

	.nps-submit-btn {
		padding: 10px 20px;
		font-size: 14px;
	}

	.nps-loading-container {
		padding: 15px;
		gap: 12px;
	}

	.nps-spinner {
		width: 35px;
		height: 35px;
		border-width: 3px;
	}

	.nps-loading-text {
		font-size: 14px;
	}

	.nps-initial-spinner {
		width: 50px;
		height: 50px;
		border-width: 4px;
	}

	.nps-initial-loading-text {
		font-size: 16px;
	}

	.nps-error-content {
		padding: 30px 15px;
	}

	.nps-error-icon {
		margin-bottom: 15px;
	}

	.nps-error-icon svg {
		width: 60px;
		height: 60px;
	}

	.nps-error-title {
		font-size: 20px;
		margin-bottom: 12px;
	}

	.nps-error-message {
		font-size: 16px;
	}

	.nps-id-label {
		font-size: 20px;
		padding: 10px 20px;
		letter-spacing: 1.5px;
	}

  }

  @media (max-width: 480px) {
	.signin-box {
		padding: 25px 15px;
	}

	.nps-button {
		width: 40px;
		height: 40px;
		font-size: 14px;
	}

	.nps-buttons-container {
		gap: 6px;
	}

	.nps-logo {
		width: 140px !important;
	}

	.nps-loading-container {
		padding: 12px;
		gap: 10px;
	}

	.nps-spinner {
		width: 30px;
		height: 30px;
		border-width: 3px;
	}

	.nps-loading-text {
		font-size: 12px;
	}

	.nps-initial-spinner {
		width: 45px;
		height: 45px;
		border-width: 4px;
	}

	.nps-initial-loading-text {
		font-size: 14px;
	}

	.nps-error-content {
		padding: 25px 15px;
	}

	.nps-error-icon {
		margin-bottom: 12px;
	}

	.nps-error-icon svg {
		width: 50px;
		height: 50px;
	}

	.nps-error-title {
		font-size: 18px;
		margin-bottom: 10px;
	}

	.nps-error-message {
		font-size: 15px;
	}

	.nps-id-label {
		font-size: 18px;
		padding: 10px 20px;
		letter-spacing: 1.5px;
	}
  }

  /* Container de Desinscrição */
  .nps-unsubscribe-container {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 50vh;
	padding: 40px 20px;
  }

  .nps-unsubscribe-content {
	text-align: center;
	padding: 40px 10px;
  }

  .nps-unsubscribe-header {
	margin-bottom: 30px;
  }

  .nps-unsubscribe-button-container {
	margin-top: 30px;
  }

  @media (max-width: 768px) {
	.nps-unsubscribe-content {
		padding: 30px 15px;
	}

	.nps-unsubscribe-header {
		margin-bottom: 20px;
	}

	.nps-unsubscribe-header .nps-logo {
		width: 200px !important;
	}
  }

  @media (max-width: 480px) {
	.nps-unsubscribe-content {
		padding: 25px 15px;
	}

	.nps-unsubscribe-header {
		margin-bottom: 15px;
	}

	.nps-unsubscribe-header .nps-logo {
		width: 140px !important;
	}
  }
  </style>
